<template>
  <div>
    <div class="text-white min-h-screen flex flex-col p-4">
      <div class="flex-grow relative z-10">
        <div class=" max-w-md mx-auto">
          <div v-if="!helpers.showForm">
            <h2 class="text-xl font-medium mb-1">Why SML Finance?</h2>

            <p class="text-sm">
              <FontAwesomeIcon class="text-blue-500" :icon="icons.faCheck" />
              Best rates, no processor lock-in
            </p>
            <p class="text-sm">
              <FontAwesomeIcon class="text-blue-500" :icon="icons.faCheck" />
              Store cattle from £16.00 / head
            </p>
            <p class="text-sm">
              <FontAwesomeIcon class="text-blue-500" :icon="icons.faCheck" />
              Leave unused overdraft capacity
            </p>

            <h2 class="text-lg font-medium mb-2 mt-6">Select Category</h2>

            <div class="flex flex-wrap -mx-1">
              <div v-for="i in 6" :key="`finance-type-${i}`" class="w-1/2 p-1">
                <div @click="helpers.showForm = true" class="bg-blue-600 rounded p-3 text-center hover:bg-blue-700">
                  <FontAwesomeIcon :icon="icons.faCow" />
                  Store Cattle
                </div>
              </div>
            </div>

            <!--
            <div class="flex mt-4 items-center justify-center">
              <div class="h-12 w-12 rounded bg-blue-500 mr-2">
                I
              </div>
              <div class="leading-tight">
                <span class="text-blue-400 text-xs">Marketing Leading</span>
                <h3 class="text-lg font-semibold">Store Cattle Finance</h3>
                <p class="text-gray-300 leading-none">from £16.00 per head</p>
              </div>
            </div>
            -->
          </div>

          <form class="form form-inverted mt-4" v-if="helpers.showForm">
            <div class="form-group mb-5">
              <label class="form-label">Finance Type</label>
              <div class="form-field form-field-xl">
                <select>
                  <option value="">Please Select</option>
                </select>
              </div>
            </div>

            <div class="form-group mb-5">
              <label class="form-label">Borrowing Amount</label>
              <div class="form-field form-field-xl">
                <input />
              </div>
            </div>

            <div class="form-group mb-5">
              <label class="form-label">Term Length</label>
              <div class="form-field form-field-xl">
                <select>
                  <option value="">Please Select</option>
                </select>
              </div>
            </div>

            <button class="btn btn-block border-blue-800 bg-blue-700 text-white">Get Quote</button>
          </form>
        </div>
      </div>
      <div class="flex-shrink relative z-10">
        <div class="flex justify-between items-center">
          <img src="@/assets/img/logo-fca.png" class="img-grayscale img-invert block h-8 w-auto" />
          <img src="@/assets/img/logo-farmpay.png" class="img-invert block h-8 w-auto" />
        </div>
      </div>
    </div>
    <div class="absolute bg-gray-900 top-0 left-0 w-full h-full z-0">
      <div class="bg-dairy absolute top-0 left-0 w-full h-full z-0 opacity-25"></div>
    </div>
  </div>
</template>

<script>
import { faCow, faSheep, faCheck } from '@fortawesome/pro-regular-svg-icons'

export default {
  data() {
    return {
      helpers: {
        showForm: false
      },
      icons: {
        faCow,
        faSheep,
        faCheck
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-dairy {
  @apply bg-cover;
  background-image: url('../assets/img/bg/dairy-cattle.jpg');
}
</style>
